import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { WORK_DAY_FIND_SUCCESS, NOTIFICATION_SUBSCRIBE } from '@store/actions';
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(
    private store: Store
  ) {}

  async initPush() {
    try {
      // Solo compatibilidad web
      // Inicializar Firebase solo si no está inicializado
      if (!getApps().length) {
        initializeApp(environment.firebaseConfig);
      }
      const messaging = getMessaging();
      // Solicitar permiso y obtener token
      try {
        // Intentar obtener token con VAPID key si está disponible
        let token;
        if (environment.vapidKey) {
          token = await getToken(messaging, {
            vapidKey: environment.vapidKey
          });

          this.store.dispatch(NOTIFICATION_SUBSCRIBE({token}))
        } else {
          // Si no hay VAPID key, intentar sin él (puede no funcionar en producción)
          console.warn('No hay VAPID key configurado. Las notificaciones pueden no funcionar correctamente.');
          token = await getToken(messaging);
          this.store.dispatch(NOTIFICATION_SUBSCRIBE({token}))

        }
      } catch (err) {
        console.error('No se pudo obtener el token de FCM Web:', err);
        // No lanzar el error, solo loggearlo para evitar que rompa la aplicación
      }

      onMessage(messaging, (payload) => {
        // payload.data['payload'] es un string JSON

        const data = payload.data;
        if (data && data['payload']) {
          try {
            const arr = JSON.parse(data['payload']); // Esto es un array de objetos
            if (Array.isArray(arr) && arr.length > 0) {
              const evento = arr[0].event; // Aquí accedes a 'close-day'
              // Puedes hacer lo que quieras con el evento aquí
              if(evento == 'close-day'){
                this.store.dispatch(WORK_DAY_FIND_SUCCESS({workDay: null}))
              }

              // if(evento == 'sync-all'){
              // }
            }
          } catch (e) {
            console.error('Error al parsear el payload:', e);
          }
        }
      });
    } catch (error) {
      console.error('Error inicializando notificaciones:', error);
      // No lanzar el error, solo loggearlo
    }
  }
}

